import { RelatorioService } from './relatorio.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as pdfMake from '../../../node_modules/pdfmake/build/pdfmake.js';
import * as pdfFonts from '../../../node_modules/pdfmake/build/vfs_fonts.js';
import { NgxUiLoaderService } from 'ngx-ui-loader';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root'
})
export class EstadoService {
  items: any;
  envi: any;
  versao: any = '1.67';
  nomePessoa: any = 'DIVIPREV';
  constructor(public router: Router, private rel: RelatorioService, private loader: NgxUiLoaderService) {
    this.items = new BehaviorSubject<{}>([]);
    this.envi = new BehaviorSubject<{}>([]);
  }

  casa: boolean = false; // marcar quando trabalhar de casa
  servidorLogin: string = this.casa ? "http://187.0.182.92:3000" : "http://10.1.150.200:3000";
  servidorCentral: string = this.casa ? "http://187.0.182.92:3001/main/controler2.php" : "https://app.diviprev.mg.gov.br/controller/controler.php";
  //   servidorCentral: string = this.casa?"http://187.0.182.92:3001/main/controler2.php":"http://localhost/censo_app/daoPHP/controler.php";
  servidorBeneficios: string = this.casa ? "http://187.0.182.92:3001/main/controler.php" : "http://10.1.150.200/main/controler.php";
  qualificadores = [
    { label: 'Aposentado', value: 'aposentado' },
    { label: 'Pensionista', value: 'pensionista' },
    { label: 'Segurado', value: 'segurado' },
    { label: 'Visitante', value: 'visitante' },
    { label: 'Acompanhante', value: 'acompanhante' },
    { label: 'Prestador de Serviços', value: 'prestador' }

  ];

  menuPrincipal: boolean = false;
  FLAG_USER: string = "logadoRescenceante";
  MINUTOS_LOGOUT: number = 380;
  CICLICO: boolean = false;


  isLogado() {
    let logado = localStorage.get(this.FLAG_USER);
    if (logado) return true;
  }

  removeAcentoCaixaAlta(palavra) {
    return ((palavra + '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")).toUpperCase();
  }

  getVersao() {
    return this.versao;
  }

  setLogado(us) {
    localStorage.setItem(this.FLAG_USER, us);
  }

  itemAleatorio(array: any) {
    if (!array.length) return null;
    const indice = Math.floor(Math.random() * array.length);
    return array[indice];
  }


  submeterDeCliente(d: any) {
    const telefone = d.telefone;
    const mensagem = d.mensagem;

    const dados = {
      id_empresa: "72",
      numero: telefone,
      id: 0,
      nome: "Denis",
      mensagem: mensagem
    };

    fetch('https://www.onesolucoes.com.br/apiWhatsappV4/enviarMensagemDireto', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dados)
    })
      .then(response => response.json()) // ou .text() dependendo do retorno
      .then(data => {
        console.log('Resposta:', data);
      })
      .catch(error => {
        console.error('Erro:', error);
      });
  }


  formatarData(dataSql) {
    if (!dataSql) return '';
    const [ano, mes, dia] = dataSql.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  shuffleString(str, seed) {
    let arr = str.split('');
    let n = arr.length;

    // Fisher-Yates Shuffle determinístico usando uma seed
    for (let i = n - 1; i > 0; i--) {
      let j = Math.floor((seed % (i + 1)));
      // Swap
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.join('');
  }

  unshuffleString(str, seed) {
    let arr = str.split('');
    let n = arr.length;
    let indices = Array.from(Array(n).keys());

    // Rastreia o que o shuffle fez com os índices
    for (let i = n - 1; i > 0; i--) {
      let j = Math.floor((seed % (i + 1)));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }

    // Reconstrói a string original
    let original = new Array(n);
    for (let i = 0; i < n; i++) {
      original[indices[i]] = arr[i];
    }
    return original.join('');
  }

  KEY_SEGURO = 'x772b';
  SEED = 1255;
  save(chave: any, valor: any) {
    let ob = this.load();
    if (ob == null) ob = Object.create(null);
    ob[chave] = valor;
    const val = this.shuffleString(btoa(JSON.stringify(ob)), this.SEED);
    localStorage.setItem(this.KEY_SEGURO, val);
  }

  load() {
    try {
      let item = localStorage.getItem(this.KEY_SEGURO);
      let dec = this.unshuffleString(item, this.SEED);
      let decodificado = atob(dec);
      if (item) return JSON.parse(decodificado);
    } catch (erro) {
      return null;
    }
  }

  soNumeros(palavra: any) {
    const alvos = '0123456789';
    return (palavra + '').split('').filter((l: any) => alvos.includes(l)).join('');
  }

  formatarWhatsapp(tel: string) {
    if (!tel) return '';
    const num = tel.replace(/\D/g, '');
    if (num.length === 11) {
      return `(${num.substring(0, 2)}) ${num.substring(2, 3)} ${num.substring(3, 7)}-${num.substring(7)}`;
    } else if (num.length === 10) {
      return `(${num.substring(0, 2)}) ${num.substring(2, 6)}-${num.substring(6)}`;
    }
    return tel;
  }

  gerarCodigoAlfanumerico(tamanho = 4) {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let resultado = '';

    for (let i = 0; i < tamanho; i++) {
      const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
      resultado += caracteres.charAt(indiceAleatorio);
    }

    return resultado;
  }

  meses: any = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro'
  };
  mesExtenso(num) {
    return this.meses[num];
  }

  async gerarPDF(obj, nome) {
    this.loader.start();
    let docDefinition = {
      pageSize: 'A4',
      content: []
    };
    let doc = docDefinition.content;
    let imagem = await this.rel.carregarImagemBase64('assets/imagens/logo100.jpg');
    let ass1 = null;
    if (!(nome == 'dadias')) ass1 = await this.rel.carregarImagemBase64('assets/assinaturas/' + nome + '.png');

    docDefinition.content.push(this.rel.imagemCentralizada(imagem));
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    docDefinition.content.push(this.rel.miniSubtitulo("Comprovante de Realização do Censo " + obj.identi));
    doc.push(this.rel.textoLimpoDireitaGrande("Protocolo #" + obj.protocolo));
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push({ text: ['     O segurado ', this.rel.negrito(obj.nome, 12), ', realizou o censo previdenciário relativo ao ano de ', this.rel.negrito(obj.ano, 12), ' e, seus dados e documentação foram conferidos e atestados pelo servidor(a) ', this.rel.negrito(obj.servidor, 12), ', na data de ', this.rel.negrito(obj.dataRealizacao, 12), ' às ', this.rel.negrito(obj.momento, 12), '.'] });
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.textoLimpoDireita('Portanto, o segurado fica quite com suas obrigações relativas ao recenseamento supracitado.'));
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.textoLimpoDireita('Divinópolis, ' + obj.dia + ' de ' + obj.mes + ' de ' + obj.ano + '.'));
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    if (!ass1) doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());
    doc.push(this.rel.espacoEmBranco());


    let ass2 = await this.rel.carregarImagemBase64('assets/assinaturas/dadias.png');
    let ass3 = await this.rel.carregarImagemBase64('assets/assinaturas/aguinaldo.png');
    if (ass1) docDefinition.content.push(this.rel.imagemCentralizadaAssinatura(ass1));
    docDefinition.content.push(this.rel.imagemCentralizadaAssinatura(ass2));
    docDefinition.content.push(this.rel.imagemCentralizadaAssinatura(ass3));




    pdfMake.createPdf(docDefinition).download('Comprovante_Censo');

    this.loader.stop();
  }

  getQualificadores() {
    return this.qualificadores;
  }

  getUsuarioLogado() {
    let ul = localStorage.getItem(this.FLAG_USER);
    if (ul) return JSON.parse(ul);
    return null;
  }

  limparCache() {
    let ul = localStorage.getItem('ultimoLogado');
    localStorage.clear();

    localStorage.setItem("ultimoLogado", ul);
  }

  logOut() {
    this.CICLICO = false;
    localStorage.removeItem(this.FLAG_USER);
    this.limparCache();


  }

  getDiferencaMinutosData() {
    var startTime = new Date(this.getUsuarioLogado().ultima_sessao);
    var endTime = new Date();
    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
    return Math.round(difference / 60000);
  }



  usuarioEstaAutenticado() {
    if (!this.getUsuarioLogado()) return false;


    if (this.getDiferencaMinutosData() < this.MINUTOS_LOGOUT) {

      return true;
    }

    this.logOut();
    return false;


  }





  getServidorLogin() {
    return this.servidorLogin;
  }

  getServidorCentral() {
    return this.servidorCentral;
  }

  getServidorBeneficios() {
    return this.servidorBeneficios;
  }

  usuarioLogado: any;




}
